import { Injectable } from "@angular/core";

/**
 * Shared, behaviour-preserving extractions of the byte-identical (ignoring
 * whitespace) blocks that were duplicated between MedicalQuestionsComponent and
 * ProcedureComponent.
 *
 * Each method uses the context-delegation pattern: the calling component passes
 * itself as `ctx`, and the previously inline `this.X` references become
 * `ctx.X`, so the extracted logic behaves exactly as before.
 */
@Injectable({
  providedIn: "root",
})
export class MedicalProcedureSharedService {
  /**
   * Extraction of the byte-identical tail of both components' `ngOnInit`, which
   * mirrors the persisted test-center and state names onto the shared
   * SupportService subjects.
   */
  emitTestCenterAndStateNames(ctx: any): void {
    if (localStorage.getItem("testCenterName") != null) {
      ctx.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      ctx.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  /**
   * Extraction of the byte-identical `getCurrentIPAddress()` bodies shared by
   * both components.
   */
  getCurrentIPAddress(ctx: any): void {
    ctx.appservice.getCurrentIPAddress().subscribe(
      (res) => {
        if (res && res["ip"]) {
          ctx.getAddressBasedonCurrentIp(res["ip"]);
        }
      },
      (err) => {
        ctx.appservice.sessionOut(err);
      }
    );
  }

  /**
   * Extraction of the byte-identical `removetcprocedure(...).subscribe(...)`
   * handler shared by both components' `removeprocedures(i)` methods. The
   * request payload is built by each caller (it differs between the two), then
   * passed in as `data`.
   */
  removeTcProcedure(ctx: any, data: any, i: number): void {
    ctx.appservice.removetcprocedure(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          ctx.TCProceduresList.splice(i, 1);
          ctx.Message = ctx.selectedlang.proceduredeleted;
        }
        if (res && res["status"] && res["status"]["status"] === 204) {
          ctx.Message = "";
          ctx.errorMessage = ctx.selectedlang.norec;
        }
        if (res && res["status"] && res["status"]["status"] === 230) {
          ctx.Message = "";
          ctx.errorMessage = ctx.selectedlang.dataRequired;
        }
        setTimeout(() => {
          ctx.Message = "";
        }, 5000);
      },
      (err) => {
        ctx.appservice.sessionOut(err);
      }
    );
  }
}
